import {
  GetCredentialsResponse,
  UploadCredentialResponse,
  DeleteCredentialResponse,
  UploadCredentialRequest,
} from '~/types/backend';
import {
  GET_CREDENTIAL_LIST,
  GET_CREDENTIAL_LIST_OK,
  GET_CREDENTIAL_LIST_ERR,
  GET_CREDENTIAL_LIST_ITEM,
  GET_CREDENTIAL_LIST_ITEM_OK,
  GET_CREDENTIAL_LIST_ITEM_ERR,
  DELETE_CREDENTIAL_LIST_ITEM,
  DELETE_CREDENTIAL_LIST_ITEM_OK,
  DELETE_CREDENTIAL_LIST_ITEM_ERR,
  DO_CREDENTIAL_LIST_CLEANUP,

  UPLOAD_CREDENTIAL,
  UPLOAD_CREDENTIAL_OK,
  UPLOAD_CREDENTIAL_ERR,
  DO_CREDENTIAL_FORM_CLEANUP,
} from "./actionTypes";

/********** LIST **********/

export const getCredentialList = (id: number) => ({
  type: GET_CREDENTIAL_LIST,
  payload: { id },
});

export const getCredentialListOk = (response: GetCredentialsResponse) => ({
  type: GET_CREDENTIAL_LIST_OK,
  payload: { response },
});

export const getCredentialListErr = (error: Error) => ({
  type: GET_CREDENTIAL_LIST_ERR,
  payload: { error },
});

export const getCredentialListItem = (id: number) => ({
  type: GET_CREDENTIAL_LIST_ITEM,
  payload: { id },
});

export const getCredentialListItemOk = (id: number, response: GetCredentialsResponse) => ({
  type: GET_CREDENTIAL_LIST_ITEM_OK,
  payload: { id, response },
});

export const getCredentialListItemErr = (id: number, error: Error) => ({
  type: GET_CREDENTIAL_LIST_ITEM_ERR,
  payload: { id, error },
});

export const deleteCredentialListItem = (id: number) => ({
  type: DELETE_CREDENTIAL_LIST_ITEM,
  payload: { id },
});

export const deleteCredentialListItemOk = (id: number, response: DeleteCredentialResponse) => ({
  type: DELETE_CREDENTIAL_LIST_ITEM_OK,
  payload: { id, response },
});

export const deleteCredentialListItemErr = (id: number, error: Error) => ({
  type: DELETE_CREDENTIAL_LIST_ITEM_ERR,
  payload: { id, error },
});

export const doCredentialListCleanup = () => ({
  type: DO_CREDENTIAL_LIST_CLEANUP,
});

/********** FORM **********/

export const uploadCredential = (data: UploadCredentialRequest) => ({
  type: UPLOAD_CREDENTIAL,
  payload: { data },
});

export const uploadCredentialOk = (response: UploadCredentialResponse) => ({
  type: UPLOAD_CREDENTIAL_OK,
  payload: { response },
});

export const uploadCredentialErr = (error: Error) => ({
  type: UPLOAD_CREDENTIAL_ERR,
  payload: { error },
});

export const doCredentialFormCleanup = () => ({
  type: DO_CREDENTIAL_FORM_CLEANUP,
});
